class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.incrementors = this.querySelectorAll('[data-incrementor]');
    this.init();
  }

  updateQuantity(event) {
    const incrementDirection = event.target.dataset.incrementor;
    const quantity = parseInt(this.querySelector('input').value, 10);

    if (
      incrementDirection === 'plus' &&
      parseInt(this.input.max, 10) > quantity
    ) {
      this.input.value = quantity + 1;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (
      incrementDirection === 'minus' &&
      parseInt(this.input.min, 10) < quantity
    ) {
      this.input.value = quantity - 1;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateQuantityInput(event) {
    if (
      parseInt(event.currentTarget.value, 10) > parseInt(this.input.max, 10)
    ) {
      this.input.value = this.input.max;
    }
  }

  init() {
    this.incrementors.forEach((incrementor) => {
      incrementor.addEventListener('click', this.updateQuantity.bind(this));
    });

    this.input.addEventListener('input', this.updateQuantityInput.bind(this));

    this.input.addEventListener('change', (event) => {
      // eslint-disable-next-line no-param-reassign
      if (!event.currentTarget.value) event.currentTarget.value = 1;
    });
  }
}
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
